import api from '../config/api';
import { Audience } from '../models/audiences/types';

export interface AudienceResource {
  id: string;
  type: string;
  attributes: Audience;
}

export interface AudiencesIndexResponse {
  data: AudienceResource[];
  meta: {
    page_number: number;
    page_size: number;
    total_objects: number;
    total_pages: number;
  };
}

export interface AudiencesIndexParams {
  page?: number;
  per_page?: number;
  q?: string;
}

class AudiencesService {
  fetchAll = (params?: AudiencesIndexParams) => {
    return api.get<AudiencesIndexResponse>('/audiences', { params });
  };
}

export default AudiencesService;
